module.exports = __webpack_public_path__ + "img/1f3c2-1f3fc.bb123f5.svg";